/* ONE10 September 2026: populate missing sock photography, never size an empty gallery. */
(function () {
  function populateSockShowcases() {
    document.querySelectorAll('template[data-one10-sock-showcase]').forEach(function (template) {
      const productRoot = template.closest('product-info');
      if (!productRoot || productRoot.dataset.productId !== template.dataset.one10SockShowcase) return;
      const wrapper = productRoot.querySelector('.wknd-media-container-wrapper');
      // Never replace existing curated visuals or initialise the same gallery twice.
      if (!wrapper || wrapper.querySelector('img, video, iframe, .one10-sock-detail-gallery')) return;
      const content = template.content.cloneNode(true);
      if (!content.querySelector('.one10-sock-detail-gallery img')) return;
      wrapper.replaceChildren(content);
      wrapper.hidden = false;
      wrapper.classList.add('one10-sock-showcase-filled');
      template.remove();
    });
  }

  function initialiseShowcase() {
    populateSockShowcases();
  const showcaseSlider = document.querySelector('.wknd-product-showcase-slider');
  const showcaseTrack = showcaseSlider ? showcaseSlider.querySelector('.wknd-product-showcase-track') : null;
  
  if (showcaseSlider && showcaseTrack) {
    const showcaseSlides = showcaseTrack.querySelectorAll('.wknd-product-showcase-slide');
    const wrapper = showcaseSlider.closest('.wknd-media-container-wrapper');
    const paginationContainer = wrapper ? wrapper.querySelector('.wknd-product-showcase-pagination') : null;

    // This is the original blank-space defect: no slides must mean no reserved screen height.
    if (showcaseSlides.length === 0) {
      showcaseSlider.hidden = true;
      showcaseSlider.style.height = '0px';
      showcaseTrack.style.height = '0px';
      if (paginationContainer) paginationContainer.hidden = true;
      const caption = wrapper ? wrapper.querySelector('.wknd-caption-text') : null;
      if (wrapper && !wrapper.querySelector('img, video, iframe') && !(caption && caption.textContent.trim())) {
        wrapper.hidden = true;
      }
      return;
    }
    if (showcaseSlider.dataset.one10ShowcaseReady === 'true') return;
    showcaseSlider.dataset.one10ShowcaseReady = 'true';

    if (paginationContainer && showcaseSlides.length > 0) {
      // Dynamically create pagination dots based on the number of slides
      paginationContainer.innerHTML = ''; // Clear any existing dots
      showcaseSlides.forEach((slide, index) => {
        const dot = document.createElement('span');
        dot.classList.add('wknd-pagination-dot');
        dot.dataset.slideIndex = index; // Set data-slide-index for tracking
        paginationContainer.appendChild(dot);
      });
    }

    const paginationDots = paginationContainer ? paginationContainer.querySelectorAll('.wknd-pagination-dot') : [];
    const heightReduction = 100; // Reduce the height by 100px from the current screen height

    // Set the slider height to the screen height for mobile devices only
    function setSliderHeightForMobile() {
      if (window.innerWidth <= 768) {
        const newHeight = window.innerHeight - heightReduction;
        showcaseSlider.style.height = `${newHeight}px`;
        showcaseTrack.style.height = `${newHeight}px`;
      } else {
        showcaseSlider.style.height = '';
        showcaseTrack.style.height = '';
      }
    }

    // Update active dot
    function updateActiveDot(index) {
      paginationDots.forEach((dot, i) => {
        dot.classList.toggle('active', i === index);
      });
    }

    // Initial setup
    setSliderHeightForMobile();
    updateActiveDot(0); // Set the first dot as active

    // Update the height dynamically if the window is resized
    window.addEventListener('resize', setSliderHeightForMobile);

    // Variables for touch events
    let startX = 0;
    let isDragging = false;
    let currentIndex = 0;
    let currentTranslate = 0;
    let prevTranslate = 0;

    // Set up the touch start event listener (marked as passive)
    showcaseSlider.addEventListener(
      'touchstart',
      (e) => {
        if (window.innerWidth > 768) return; // Skip for non-mobile
        isDragging = true;
        startX = e.touches[0].clientX;
        showcaseTrack.style.transition = 'none'; // Disable transition during dragging
      },
      { passive: true } // Mark event listener as passive
    );

    // Set up the touch move event listener (marked as passive)
    showcaseSlider.addEventListener(
      'touchmove',
      (e) => {
        if (!isDragging || window.innerWidth > 768) return; // Skip for non-mobile

        const currentX = e.touches[0].clientX;
        const deltaX = currentX - startX;
        currentTranslate = prevTranslate + deltaX;

        // Apply the translation directly to the track element
        showcaseTrack.style.transform = `translateX(${currentTranslate}px)`;
      },
      { passive: true } // Mark event listener as passive
    );

    // Set up the touch end event listener
    showcaseSlider.addEventListener('touchend', () => {
      if (!isDragging || window.innerWidth > 768) return; // Skip for non-mobile
      isDragging = false;

      // Calculate the slide width to determine if the slide should change
      const slideWidth = showcaseSlider.clientWidth;
      const moveThreshold = slideWidth / 4; // 25% of the width to trigger a change
      const movedBy = currentTranslate - prevTranslate;

      if (Math.abs(movedBy) > moveThreshold) {
        // Move to next or previous slide depending on swipe direction
        if (movedBy < 0 && currentIndex < showcaseSlides.length - 1) {
          currentIndex++;
        } else if (movedBy > 0 && currentIndex > 0) {
          currentIndex--;
        }
      }

      prevTranslate = currentIndex * -slideWidth;

      // Reset transform to snap to the current slide
      showcaseTrack.style.transition = 'transform 0.3s ease-in-out';
      showcaseTrack.style.transform = `translateX(${prevTranslate}px)`;

      // Update pagination dots
      updateActiveDot(currentIndex);
    });

    // Set up click event for pagination dots
    paginationDots.forEach((dot) => {
      dot.addEventListener('click', () => {
        currentIndex = parseInt(dot.dataset.slideIndex, 10);
        prevTranslate = currentIndex * -showcaseSlider.clientWidth;
        showcaseTrack.style.transition = 'transform 0.3s ease-in-out';
        showcaseTrack.style.transform = `translateX(${prevTranslate}px)`;

        // Update pagination dots
        updateActiveDot(currentIndex);
      });
    });

    // Ensure the first slide is properly positioned on load
    showcaseTrack.style.transform = `translateX(${prevTranslate}px)`;
  }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialiseShowcase, { once: true });
  } else {
    initialiseShowcase();
  }
  document.addEventListener('shopify:section:load', initialiseShowcase);
})();
